<div class="auth-page">
  <div class="auth-card">
    <div class="auth-header">
      <img src="Logo_QRserve.png" alt="QRServe" class="auth-logo">
      <h2 class="auth-title">Forgot Password</h2>
      <p class="auth-subtitle">Enter your email and we'll send you a reset code</p>
    </div>

    <form [formGroup]="forgotForm" (ngSubmit)="onSubmit()">
      <div class="form-group">
        <label for="email" class="form-label">Email address</label>
        <div class="input-wrapper">
          <i class="fas fa-envelope input-icon"></i>
          <input type="email"
                 id="email"
                 formControlName="email"
                 class="form-control"
                 placeholder="you@company.com">
        </div>
      </div>

      <button type="submit"
              class="btn btn-primary btn-block submit-btn"
              [disabled]="forgotForm.invalid || isLoading">
        @if (!isLoading) {
          Send Reset Code
        } @else {
          <span class="spinner"></span>
          Sending...
        }
      </button>
    </form>

    <div class="auth-footer">
      <a [routerLink]="['/login']"><i class="fas fa-arrow-left me-1"></i> Back to login</a>
    </div>
  </div>
</div>
